// Copyright (c) 2026 Dyna Robotics, Inc. All rights reserved.
// Dyna Robotics Proprietary and Confidential.
// Unauthorized copying, use, or distribution is prohibited.
// SPDX-License-Identifier: LicenseRef-Dyna-Internal

/**
 * The Cybertron mark: an open hexagon — a nut, the hardware the archive keeps track of —
 * that reads as a C, around a dot for the one part being followed. The faint dot in the
 * gap is the next version, not yet fitted.
 *
 * The same drawing is `public/favicon.svg`; change both together.
 */

import { useId } from "react";

export function BrandMark({ size = 30 }: { size?: number }) {
  const gradient = useId();
  return (
    <svg
      className="brand-mark"
      width={size}
      height={size}
      viewBox="0 0 32 32"
      aria-hidden="true"
      focusable="false"
    >
      <defs>
        <linearGradient id={gradient} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#3b82f6" />
          <stop offset="1" stopColor="#1d4ed8" />
        </linearGradient>
      </defs>
      <rect width="32" height="32" rx="8" fill={`url(#${gradient})`} />
      <path
        d="M21 7.34H11L6 16l5 8.66h10"
        fill="none"
        stroke="#fff"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="16.5" cy="16" r="2.75" fill="#fff" />
      <circle cx="25.2" cy="16" r="1.6" fill="#fff" fillOpacity=".55" />
    </svg>
  );
}
